module.exports = __webpack_public_path__ + "static/media/collapse-after.aa40866a.svg";